import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["textMode", "voiceMode", "modeText"]

  connect() {
    this.isVoiceMode = false
  }

  toggleMode() {
    this.isVoiceMode = !this.isVoiceMode

    if (this.isVoiceMode) {
      // Switch to voice mode
      this.textModeTargets.forEach(el => el.classList.add("hidden"))
      this.voiceModeTarget.classList.remove("hidden")
      this.modeTextTarget.textContent = "Text Mode"
    } else {
      // Switch to text mode - reload to show all messages
      const chatId = window.location.pathname.split('/').filter(Boolean).pop()
      if (chatId && !isNaN(chatId)) {
        window.Turbo.visit(`/chats/${chatId}`, { action: "replace" })
      } else {
        // Fallback: just show text mode without reload
        this.textModeTargets.forEach(el => el.classList.remove("hidden"))
        this.voiceModeTarget.classList.add("hidden")
        this.modeTextTarget.textContent = "Voice Mode"
      }
    }
  }
}
